export default {
    MEGABYTE: 1000000
}
